// Indentation of nested groups on screen (no fixed limit on chart levels, migration 035). Past a dozen levels the
// indent stops growing so deep charts stay readable on a phone; the level and path still say where a row is.
export const MAX_INDENT_LEVELS = 12;
export const indentPx = (levels: number, step: number, base = 0) => base + Math.min(Math.max(0, levels), MAX_INDENT_LEVELS) * step;
export const indentText = (levels: number, unit: string) => unit.repeat(Math.min(Math.max(0, levels), MAX_INDENT_LEVELS));
